<template>
<!--    <div>
    <div v-for="(key, idx) in Object.keys(row)" :key="idx">
        {{key}}:{{row[key]}}
    </div>
    </div>-->
    <div>
        <nav-breadcrumb :menu="[{label: '法务大数据查询'}]"/>
                    <div  v-for="(key, idx) in Object.keys(row)" :key="idx">
                        <panel :label="Status2CN(key)" v-if="Array.isArray(row[key])&&key!=='code'&&key!=='msg'&&key!=='searchSeconds'&&key!=='totalCount'">
                           <div v-for="(item, idx1) in row[key]" :key="idx1">
                               <div v-if=" typeof item === 'object' && !Array.isArray(item) && item !== null">
                                   <el-form :model="dataForm" ref="dataForm" label-width="180px">
                                       <panel class="tableline2" border>
                                           <div  v-for="(key1, idx) in Object.keys(item)" :key="idx">
                                               <el-form-item :label="((labelCN(key+'CN')||'')[key1]||key1)+':'" v-if="typeof item[key1] === 'string' || typeof item[key1] === 'number' || typeof item[key1] === 'boolean'">
                                                   <div v-if="key1 ==='body'" v-html="item[key1]">
                                                   </div>
                                                   <div v-else>{{item[key1]}}</div>
                                               </el-form-item>
                                               <el-form-item :label="((labelCN(key+'CN')||'')[key1]||key1)+':'" v-else-if="Array.isArray(item[key1])">
                                                   <el-collapse accordion>
                                                       <el-collapse-item  v-for="(item1, idx2) in item[key1]" :key="idx2" :title="'第'+(idx2+1)+'条'" :name="idx2">
                                                           <div v-if=" typeof item1 === 'object' && !Array.isArray(item1) && item1 !== null">
                                                               <el-form :model="dataForm" ref="dataForm" label-width="180px">
                                                                   <panel class="tableline3" border>
                                                                       <div v-for="(key2, idx) in Object.keys(item1)" :key="idx" v-if="item1[key2]">
                                                                           <el-form-item  :label="(((labelCN(key+'CN')||'')[key1+'CN']||'')[key2]||key2)+':'" v-if="typeof item1[key2] === 'string' || typeof item1[key2] === 'number' || typeof item1[key2] === 'boolean'">
                                                                               {{item1[key2]}}
                                                                           </el-form-item>
                                                                           <el-form-item :label="(((labelCN(key+'CN')||'')[key1]||'')[key2]||key2)+':'" v-if="Array.isArray(item1[key2])">
                                                                               {{item1[key2]}}
                                                                           </el-form-item>
                                                                       </div>
                                                                   </panel>
                                                               </el-form>
                                                           </div>

                                                       </el-collapse-item>
                                                   </el-collapse>
                                               </el-form-item>
<!--                                               <el-form-item :label="((labelCN(key+'CN')||'')[key1]||key1)+':'" v-else>
                                                   <div>{{item[key1]}}</div>
                                                   <el-form :model="dataForm" ref="dataForm" label-width="180px">
                                                       <panel class="tableline3" border>
                                                           <div v-for="(key2, idx) in Object.keys(item[key1])" :key="idx" v-if="item[key1][key2]">
                                                               <el-form-item  :label="(((labelCN(key+'CN')||'')[key1+'CN']||'')[key2]||key2)+':'" v-if="typeof item1[key2] === 'string' || typeof item1[key2] === 'number' || typeof item1[key2] === 'boolean'">
                                                                   {{item1[key2]}}
                                                               </el-form-item>
                                                               <el-form-item :label="(((labelCN(key+'CN')||'')[key1]||'')[key2]||key2)+':'" v-if="Array.isArray(item1[key2])">
                                                                   {{item1[key2]}}
                                                               </el-form-item>
                                                           </div>
                                                       </panel>
                                                   </el-form>
                                               </el-form-item>-->
                                           </div>
                                       </panel>
                                   </el-form>
                               </div>
                           </div>
                        </panel>
                    </div>
    </div>
</template>

<script>
import labelCN from "../../filters/LabelCN";
import Status2CN from "../../filters/Status2CN";
export default {
    name: "FaihaiQueryPersonDetailView",
    data() {
        return {
            dataForm:{},
            row: JSON.parse(JSON.stringify(JSON.parse(this.$route.query['row']||''))),
        }
    },
    mounted() {
        this.init()
    },
    methods:{
        labelCN,
        Status2CN,
        init: function (){
        }
    }

}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/fang/FaihaiQueryPersonDetailView.vue